import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    localizations: [{
        id: 1,
        name: 'Audi Krotoski Częstochowa',
        street: 'ul. Kornela Makuszyńskiego 74/76',
        postcode: '42-209',
        city: 'Częstochowa',
        phone: '+48 34 368 48 40',
        email: 'audi.czestochowa@krotoski.com',
        image: require('./assets/images/krotoski-czestochowa.jpg')
      },
      {
        id: 2,
        name: 'Audi Centrum Łódź',
        street: 'al. Wł. Bartoszewskiego 13',
        postcode: '93-341',
        city: 'Łódź',
        phone: '+48 (42) 207-74-00',
        email: 'salon@audicentrumlodz.pl',
        image: require('./assets/images/krotoski-centrum-lodz.jpg')
      },
      {
        id: 3,
        name: 'Audi Krotoski Łódź',
        street: 'ul. Niciarniana 51/53',
        postcode: '92-320',
        city: 'Łódź',
        phone: '(42) 677 17 00',
        email: 'salon.audi.lodz@krotoski.com',
        image: require('./assets/images/krotoski-lodz.jpg')
      },
      {
        id: 4,
        name: 'Audi Krotoski Wolica',
        street: 'al. Katowicka 43',
        postcode: '05-830',
        city: 'Wolica',
        phone: '+48 (22) 730 85 00',
        email: 'salon.audi.wolica@krotoski.com',
        image: require('./assets/images/krotoski_wolica.jpg')
      },
      {
        id: 5,
        name: 'Audi Krotoski Warszawa',
        street: 'ul. Radzymińska 267',
        postcode: '03-643',
        city: 'Warszawa',
        phone: '+48 22 510 35 65',
        email: 'audi.salon.warszawa@krotoski.com',
        image: require('./assets/images/krotoski_warszawa.jpg')
      },
      {
        id: 6,
        name: 'Audi Krotoski Warszawa-Białołęka',
        street: 'ul. Modlińska 57A',
        postcode: '03-199',
        city: 'Warszawa',
        phone: '+48 22 250 02 60',
        email: 'serwis.audi.bialoleka@krotoski.com',
        image: require('./assets/images/krotoski-bialoleka.jpg')
      }
    ],
    detepickerConfig: {
      formatLocale: {
        // MMMM
        months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        // MMM
        monthsShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
        // dddd
        weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
        // ddd
        weekdaysShort: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        // dd
        weekdaysMin: ['Nd', 'Po', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
        // first day of week
        firstDayOfWeek: 1
      },
      range(date) {
        var dateFrom = new Date()
        dateFrom.setDate(dateFrom.getDate() + 1)
        return dateFrom > date
      },
      disabledDays: [
        '01-01', // Nowy Rok
        '01-06', // Święto Trzech Króli
        '04-04', // Wielkanoc
        '04-05', // Poniedziałek Wielkanocny
        '05-01', // Święto Pracy
        '05-03', // Święto Konstytucji 3 Maja
        '05-23', // Zielone Świątki
        '06-03', // Boże Ciało
        '08-15', // Święto Wniebowzięcie Najświętszej Maryi Panny
        '11-01', // Wszystkich Świętych
        '11-11', // Święto Niepodległości
        '12-25', // Boże Narodzenie
        '12-26' // Boże Narodzenie
      ]
    },
    timeOfday: [{
        val: 1,
        name: 'O każdej porze',
        term: {
          hour_from: null,
          hour_to: null
        }
      },
      {
        val: 2,
        name: 'Przed południem',
        term: {
          hour_from: null,
          hour_to: 12
        }
      },
      {
        val: 3,
        name: 'Po południu',
        term: {
          hour_from: 12,
          hour_to: null
        }
      }
    ],
    services: [{
        val: 1,
        name: 'Serwis Ekspres',
        text: 'Bezpieczeństwo na drodze to sprawa priorytetowa - tak jak nasza usługa serwisowa z zakresu mechaniki pojazdowej. Wykonywana poza kolejnością, dająca możliwość ekspresowej naprawy. Szybka i skuteczna diagnoza usterki, szeroki zakres usług, krótki czas naprawy, sprawna realizacja formalności, doświadczeni fachowcy oraz profesjonalne podejście do klienta gwarantują 100% satysfakcję.  ',
        image: require('./assets/images/serwis-expres.jpg')
      },
      {
        val: 2,
        name: 'Przegląd okresowy',
        text: 'Okresowy przegląd wyznaczony przez producenta, pod kątem zużycia poszczególnych części eksploatacyjnych, olejów oraz filtrów, mający na celu wydłużenie żywotności auta.',
        image: require('./assets/images/przeglad-okresowy.jpg')
      },
      {
        val: 3,
        name: 'Elektryka pojazdu',
        text: 'Zapaliła ci się kontrolka, której nie znasz? Nie zwlekaj! Posiadamy przyrządy niezbędne do przeprowadzenia diagnostyki komponentów elektronicznych oraz elementy konieczne do ich naprawy. ',
        image: require('./assets/images/serwis-elektryki.jpg')
      },
      {
        val: 4,
        name: 'Wymiana opon',
        text: 'Profesjonalny serwis opon - kompleksowe usługi serwisowania ogumienia począwszy od sprzedaży opon i felg, montażu oraz naprawy, wraz z doradztwem w doborze odpowiednich opon do samochodu.',
        image: require('./assets/images/wymiana-opon.jpg')
      },
      {
        val: 5,
        name: 'Naprawa mechaniczna',
        text: 'Naprawy główne i bieżące układów zawieszenia, podwozia, układu kierowniczego, hamulcowego oraz silnika – by Twoje auto było poprawnie eksploatowane i w 100% bezpiecznie.',
        image: require('./assets/images/naprawa-mechaniczna.jpg')
      },
      {
        val: 6,
        name: 'Inne',
        text: 'Serwisowanie samochodu w ASO to najwyższa jakość usług, przeprowadzanych zgodnie z zaleceniami producenta. Napisz czego potrzebujesz, a nasi specjaliści sprawnie udzielą ci wsparcia.',
        image: require('./assets/images/inne.jpg')
      }
    ],
    specialOffers: [
      // {
      //   val: 1,
      //   name: 'Dezynfekcja klimatyzacji z przeglądem wakacyjnym za 349 zł',
      //   displayName: 'Dezynfekcja klimatyzacji <br> z przeglądem wakacyjnym za 349 zł',
      //   image: require('./assets/images/dezynfekcja.png'),
      //   link: "https://www.krotoski.com/klimatyzacja-349/"
      // },
      {
        val: 1,
        name: 'Korzyść do -20%',
        displayName: 'Korzyść do -20%',
        image: require('./assets/images/program-6plus-19-07-2023.png'),
        link: "https://www.krotoski.com/audi-serwis-6plus/"
      },
      // {
      //   val: 2,
      //   name: 'Akcesoria Audi w pakietach z korzyścią 25% oraz Audi Connect Plug&Play za 1 zł',
      //   displayName: 'Akcesoria Audi w pakietach z&nbsp;korzyścią 25% <br> oraz Audi Connect Plug&Play za 1 zł',
      //   image: require('./assets/images/Q4.png'),
      //   link: "https://www.krotoski.com/pakiety-serwisowe/"
      // },
      // {
      //   val: 4,
      //   name: 'Wymiana oleju z rabatem 50% + Audi Connect Plug&Play za 1 zł',
      //   displayName: 'Wymiana oleju z rabatem 50% + Audi Connect Plug&Play za 1 zł',
      //   image: require('./assets/images/wymiana-oleju-50-03-2022.png'),
      //   link: "https://www.krotoski.com/wymiana-oleju-50/"
      // },
      {
        val: 2,
        name: 'Przegląd sezonowy za 199 zł',
        displayName: 'Przegląd sezonowy <br/> za&nbsp;199&nbsp;zł',
        image: require('./assets/images/przeglad-sezonowy-13-04-2023.png'),
        link: "https://krotoski.com/przeglad199/"
      },
      {
        val: 3,
        name: 'Przegląd w abonamencie',
        displayName: 'Przegląd <br/> w abonamencie',
        image: require('./assets/images/przeglad-w-abonamencie.png'),
        link: "https://www.krotoski.com/pakiety-przegladow-serwisowych/"
      },
    ],
    lead: {
      brand_name: 'Audi',
      dealer_name: null,
      dealer_id: null,
      term_from: null,
      date: null,
      time_of_day: null,
      service: null,
      servicetemp: null,
      video_service: 'NIE',
      need_replacement_car: 'NIE',
      need_wait_for_end: 'NIE',
      door_to_door: 'NIE',
      additional_info: null,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      registration_number: '',
      vin: '',
      accept1: 'NIE',
      accept2: 'NIE',
      accept3: 'NIE'
    },
    leadToDescription: {
      brand_name: 'Marka',
      dealer_name: 'Serwis',
      term_from: 'Termin',
      date: 'Preferowana data',
      time_of_day: 'Pora dnia',
      service: 'Usługa',
      servicetemp: 'Usługa promocyjna',
      video_service: 'Krotoski Video Serwis',
      need_replacement_car: 'Samochód zastępczy',
      need_wait_for_end: 'Oczekiwanie na zakończenie naprawy',
      door_to_door: 'Door to door',
      additional_info: 'Dodatkowe informacje',
      first_name: 'Imię',
      last_name: 'Nazwisko',
      email: 'Email',
      phone: 'Numer telefonu',
      registration_number: 'Numer rejestracyjny samochodu',
      vin: 'Numer VIN',
      accept1: 'zgoda na przetwarzanie danych osobowych w celach marketingowych',
      accept2: 'zgoda na merketing telefoniczny',
      accept3: 'zgoda na przesyłanie informacji handlowych na email'
    },
    required: {
      dealer_name: 'Proszę wybrać serwis',
      term_from: 'Proszę wybrać termin',
      time_of_day: 'Proszę wybrać preferowaną porę dnia',
      service: 'Proszę wybrać usługę',
      first_name: 'Proszę podać imię',
      last_name: 'Proszę podać nazwisko',
      email: 'Proszę podać adres e-mail',
      phone: 'Proszę podać numer telefonu',
      registration_number: 'Proszę podać numer rejestracyjny',
      // vin:'Proszę podać numer VIN'

    },
    errors: {},
    valid: false,
    submitState: null
  },
  mutations: {
    setLead(state, payload) {
      state.lead = payload
    },
    setSubmitState(state, payload) {
      state.submitState = payload
    },
    setErrors(state, payload) {
      state.errors = payload
    },
    setValid(state, payload) {
      state.valid = payload
    }
  },
  getters: {
    getLocalizations: state => state.localizations,
    getDatepickerConfig: state => state.detepickerConfig,
    getTimeOfday: state => state.timeOfday,
    getServices: state => state.services,
    getSpecialOffers: state => state.specialOffers,
    getLead: state => state.lead,
    getSubmitState: state => state.submitState,
    getFirstError: state => Object.values(state.errors).find(e => e != false),
    getValid: state => state.valid
  },
  actions: {
    async submit({
      state,
      commit
    }) {

      let errors = {};
      Object.keys(state.required).map(e => errors[e] = ['', 'NIE', null, false].includes(state.lead[e]) ? state.required[e] : false);
      let valid = !Object.values(errors).find(e => e != false);
      console.log(valid);
      commit('setErrors', errors);
      commit('setValid', valid);

      if (!valid) {
        return;
      }

      let message = Object.keys(state.leadToDescription).map(e => {
        console.log(state.lead[e]);
        console.log("###########################");
        console.log(state.leadToDescription[e]);
        let value = state.lead[e] ? state.lead[e] : '-';
        return state.leadToDescription[e] + `: <strong>${value}</strong>`;
      }).join("<br>\t\n");

      const response = await axios({
        method: 'post',
        url: 'https://serwer1692804.home.pl/strony_www/LandingPage/krotoski-serwis-audi-2021/send.php',


        data: {
          message: message,
          ...state.lead
        },
        headers: {
          'Content-Type': `multipart/form-data;`,
        }
      });
      commit('setSubmitState', response.data)

    }
  }
});
